import type { Session } from "@mux/sdk/v2/client"
import { jsonObject, jsonString } from "@/transport/decode"

/** Builds a Session decoder that reports failures with the caller's message. */
export function sessionDecoder(invalid: string) {
  return (value: unknown): Session => {
    const session = jsonObject(value, invalid)
    jsonString(session.id, invalid)
    jsonString(session.projectID, invalid)
    jsonString(session.directory, invalid)
    jsonString(session.title, invalid)
    jsonObject(session.time, invalid)
    return session as Session
  }
}
